var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCloseCircle = function SvgIcCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5BE",
    fillRule: "evenodd",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.424-11.425a.6.6 0 0 1 0 .849l-2.576 2.575 2.576 2.576a.6.6 0 0 1-.849.849L12 12.848l-2.575 2.576a.6.6 0 0 1-.849-.849L11.151 12 8.575 9.424a.6.6 0 0 1 .849-.849l2.575 2.576 2.576-2.576a.6.6 0 0 1 .849 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcCloseCircle;